export default "__VITE_ASSET__CGsAzjDl__"